export const Filters = {
    countryISO: 'countryISO',
    country: 'country',
    accountCurrency: 'accountCurrency',
    isEnabled: 'isEnabled',
    shouldCreditOnRedirect: 'shouldCreditOnRedirect',
    logoUrl: 'logoUrl',
    paymentProduct: 'paymentProduct',
    bankId: 'bankId',
    MOR: 'MOR',
    recipients_exist: 'recipients_exist'
};

export const enum MenuItem {
    BankingSDK = 'BankingSDK',
    IbanXS = 'IbanXS',
    BankingSDKRecipients = 'BankingSDKRecipients',
    BankingSDKConnectorsRecipientsPivot = 'BankingSDKConnectorsRecipientsPivot',
    IbanXSBanksRecipientsPivot = 'IbanXSBanksRecipientsPivot',
    IbanXSBanksCountriesPivot = 'IbanXSBanksCountriesPivot'
};

export const enum PaymentProduct {
    Domestic = 0,
    Sepa,
    CrossBorder
};
